import { RemoteLessonId } from 'types';

export const REMOTE_LESSONS = '/api/v1/remote-lessons';
export const REMOTE_LESSON = (remoteLessonId: RemoteLessonId) =>
    `/api/v1/remote-lessons/${remoteLessonId}`;
export const REMOTE_LESSON_RECEIVERS = `${REMOTE_LESSONS}/recipients`;
